import { useEffect, useState } from "react";

export function useTableSelectionState() {
  // Track whether the full table has rendered at least once.
  // Once it has, we never replace it with a full-page loading spinner
  // (which would unmount the search input and lose focus).
  const [hasRenderedTable, setHasRenderedTable] = useState(false);

  // Anchor index for range selection (Shift+Click) — indexes into unifiedItems
  const [anchorIndex, setAnchorIndex] = useState<number | null>(null);

  // Track whether shift is held to disable text selection via CSS
  const [shiftHeld, setShiftHeld] = useState(false);
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Shift") setShiftHeld(true);
    };
    const onKeyUp = (e: KeyboardEvent) => {
      if (e.key === "Shift") setShiftHeld(false);
    };
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("keyup", onKeyUp);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("keyup", onKeyUp);
    };
  }, []);
  return { hasRenderedTable, setHasRenderedTable, anchorIndex, setAnchorIndex, shiftHeld };
}
